import { useBooking } from 'hb-react/shared/apps/Events/pages/Booking/hooks/useBooking';

import { DefaultGuestsTicketForm } from './components/Default';
import { InternalUserRegistration } from './components/InternalUserRegistration';

export const GuestsTicketForm = (props) => {
  const { event } = useBooking();

  if (event?.config?.internal_user_registration_enabled) {
    return <InternalUserRegistration {...props} />;
  }

  return <DefaultGuestsTicketForm {...props} />;
};
